export const DEFAULT_RECOVERY_COOLDOWN_MS = 30000;

// Guards signed-URL refetch attempts so a permanently failing resource cannot
// trigger a refetch loop: at most one recovery attempt per cooldown window.
export function shouldAttemptRecovery(
  lastAttemptAt: number | null,
  now: number,
  cooldownMs: number = DEFAULT_RECOVERY_COOLDOWN_MS
): boolean {
  if (!lastAttemptAt) return true;
  return now - lastAttemptAt >= cooldownMs;
}

// Keyed shared gate: recovery actions that benefit every instance (e.g. one
// areas refetch renews all preview signatures) share a cooldown per key.
const lastAttemptByKey = new Map<string, number>();

export function attemptRecovery(
  key: string,
  now: number = Date.now(),
  cooldownMs: number = DEFAULT_RECOVERY_COOLDOWN_MS
): boolean {
  if (!shouldAttemptRecovery(lastAttemptByKey.get(key) ?? null, now, cooldownMs)) {
    return false;
  }
  lastAttemptByKey.set(key, now);
  return true;
}

export function resetRecoveryGates(): void {
  lastAttemptByKey.clear();
}
